<template>
    <div
        :data-component-name="$options.name"
    >
        <div class="c-dashboard__loading" v-if="$apollo.queries.projects.loading || !showProjects">
            <q-spinner
                color="primary"
                size="1em"
            />
            Chargement en cours...
        </div>
        <div>
            <Project
                :newProject="newProject"
                @refetch-projects="refetchProjects()"
                :currentDate="currentDate"
                :weekrange="projectDateRange"
                v-if="newProject"
                @cancel="newProjectToProjectsList($event)"
                :shiftsView="shiftsView"
                :projectsFilter="projectsFilter"
                @new-project="newProjectCreated($event)"
            /><!--$emit('cancel', false)-->
        </div>
        <div v-if="showProjects==true && projectList && projectList.data">
            <!-- {{projects}} -->
            <div
                :key="project.id"
                v-for="project in projectList.data"
            >
            <!-- <pre>{{ project}}</pre> -->
                <Project
                    @deleted-projects="refetchProjects()"
                    :project="project"
                    :currentDate="currentDate"
                    :shiftsView="shiftsView"
                    :projectsFilter="projectsFilter"
                    :weekrange="projectDateRange"
                    @set-current-date="$emit('set-current-date', $event)"
                    @cancel-duplication="cancelDuplication"
                    @new-project="newProjectCreated($event)"
                    v-if="project.draftShifts.length>0
                            || project.shifts.length>0
                            || projectsFilter=='All'
                            || projectsFilter=='MyProjects'
                            || projectsFilter=='ToPlan'
                            || projectsFilter=='Archived'"
                />
            </div>
            <div
                v-if="projects && projects.paginatorInfo.hasMorePages && !$apollo.queries.projects.loading"
                ref="loadMoreProjects"
            >
                <pre style="color: white">Plus de résultats...</pre>
            </div>
        </div>


        <q-dialog v-model="projectNotFound" persistent
        >
            <q-card>
                <q-card-section class="row items-center no-wrap">
                    <q-avatar icon="warning" color="primary" text-color="white" />
                    <span class="q-ml-sm">Le projet demandé n'a pas été chargé, mais des résultats supplémentaires sont disponibles.</span>
                </q-card-section>

                <q-card-actions align="right">
                    <q-btn flat label="Cancel" color="primary" v-close-popup
                        @click="$eventBus.$emit('jump-to-project', null)"
                    />
                    <q-btn flat label="Charger plus de résultats" color="primary" v-close-popup 
                        @click="getMoreProjects()"
                    />
                </q-card-actions>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
    import { PROJECTS } from '@/graphql/project/queries'
    import Project from '@/components/projects/Project'
    import {getWeeksLimits} from '@/js/dateUtilities'
    import { MYPROFILE } from '@/graphql/user/queries'
    import uniqBy from 'lodash/uniqBy'
    import { v4 as uuidv4 } from 'uuid';

    export default {
        name: 'Projects',
        props: {
            projectIDs: {
                type: [Number, Array],
                default(){
                    return new Array()
                }
            },
            projectDateRange: {
                type: Object,
                default: function(){
                    return getWeeksLimits(this.currentDate, this.$generalSettings.settings.firstDayOfWeek)
                }
            },
            currentDate: String,
            shiftsView: {
                type: String,
                default: 'profession'
            },
            projectsFilter: {
                type: String,
                default: 'All'
            },
            newProject: {
                type: Boolean,
                default: false
            },
            scrollToProject: {
                type: String,
                default: null
            },
            moreFilters: {
                type: Object,
                default: null
            },
            order: {
                type: Object,
                default() {
                    return {
                        orderBy: 'name',
                        orderSort: 'ASC',
                    }
                }
            }
        },
        data(){
            return {
                showProjects: false,
                scrolled: false,
                justMonted: true,
                myProfileID: null,
                pageSize: 10,
                currentPage: 1,
                bodyScrollTo: null,
                loading: true,
                projectScrollToTo: null,
                projectList: null,
                lastRange: null,
                projectNotFound: false,
                notFetched: false,
                // duplicatedProject: {}
                // newProject: false
            }
        },
        components: {
            Project,
        },
        mounted: function(){
            let offset=-100;
            let moreFiltersEL=document.querySelector(".js-more-filters-nav");
            if(moreFiltersEL) offset=offset-moreFiltersEL.offsetHeight;

            if(this.scrollToProject && document.getElementById(this.scrollToProject)) this.$scrollTo('#'+this.scrollToProject, 200, {offset:offset})
            
            let passiveSupported = false;
            try {
                const options = {
                    get passive() { 
                        passiveSupported = true;
                        return false;
                    }
                };

                window.addEventListener("test", null, options);
                window.removeEventListener("test", null, options);
            } catch(err) {
                passiveSupported = false;
            }
            document.addEventListener('scroll', this.onScroll, passiveSupported ? { passive: true } : false);

            this.$eventBus.$on('jump-to-loaded-project', function(e){
                if(this.notFetched){
                    this.notFetched=false;
                    return
                }
                clearTimeout(this.projectScrollToTo);
                this.projectScrollToTo=setTimeout(function(){
                    this.scrollToFunc(e.projectID);
                }.bind(this))
            }.bind(this))

            this.$eventBus.$on('duplicate-project', this.duplicateProject)

        },
        beforeDestroy() {
            document.removeEventListener('scroll', this.onScroll);
            this.$eventBus.$off('jump-to-loaded-project');
            this.$eventBus.$off('duplicate-project');
        },
        methods: {

            cancelDuplication(project) {
                if (project.duplication) {
                    this.projectList.data = this.projectList.data.filter(item => item.id!=project.id )
                }
            },

            duplicateProject(form = null) {

                this.newProject = false;


                if (form && form.id) {
                    // let originalId = form.id
                    let newProjectObj = JSON.parse(JSON.stringify(form))
                    newProjectObj.name = newProjectObj.name + ' - copy'
                    newProjectObj.duplication = true
                    newProjectObj.projectShifts.forEach(pj => {
                        pj.id = 'duplicatedProjectShift-' + uuidv4();
                        pj.isNew = true;
                        pj.projectAssignments.forEach(function (item) {
                            // delete item.id;
                            item.id = 'duplicatedProjectAssignment-' + uuidv4();
                            // item.id="duplicatedProjectAssignment";
                        })

                    })
                    newProjectObj.id = 'duplicatedProjectAssignment-' + uuidv4();
                    newProjectObj.shifts = []
                    newProjectObj.draftShifts = []
                    this.projectList.data.unshift(newProjectObj)
                    // this.newProject = true;
                    this.$nextTick(() => {
                        this.$eventBus.$emit('toggle-project-details', newProjectObj.id);
                    })
                    setTimeout(function () {
                        let offset = -120;
                        let moreFiltersEL = document.querySelector(".js-more-filters-nav");
                        if (moreFiltersEL) offset = offset - moreFiltersEL.offsetHeight;

                        this.$scrollTo(
                            "#project-1",
                            0,
                            {
                                offset: offset,
                            }
                        )
                    }.bind(this), 250)                

                }
            },
        
            newProjectCreated(createdtedProject) {
                this.$emit('cancel');
                this.notFetched=true
                this.$eventBus.$emit('jump-to-project', { projectID: createdtedProject.id, currentDate: createdtedProject.start_date})
                this.refetchProjects();
            },

            scrollToFunc(projectID=null){
                let toID=this.scrollToProject
                if(projectID) toID=projectID;
                if(toID && document.getElementById("project"+toID) && !this.loading){

                    this.$eventBus.$emit('toggle-project-details', toID);
                    // this.$scrollTo('#project'+toID, 200, {offset:-100})
                    this.$eventBus.$emit('jump-to-project', null);
                    return true;
                }else if(!this.loading && !document.getElementById("project"+toID)){
                    if(this.projects?.paginatorInfo?.hasMorePages){
                        this.projectNotFound=true;
                    }
                    return false;
                }
                return false;
            },
            onScroll(){
                // clearTimeout(this.bodyScrollTo);
                // this.bodyScrollTo = setTimeout(function(){
                    var loadMoreEl = this.$refs["loadMoreProjects"];
                    // var loadMoreParent = document.body;
                    if (loadMoreEl) {
                        var marginTop = loadMoreEl.getBoundingClientRect().top;
                        var innerHeight = (window.innerHeight || document.documentElement.clientHeight)
                        if ((marginTop < innerHeight) && !this.loading) {
                            this.getMoreProjects()
                        }
                    }
                // }.bind(this), 300)
            },
            getMoreProjects(){
                if(!this.projects?.paginatorInfo?.hasMorePages) return;
                // if(this.projects.loading) return;

                this.currentPage=this.projects.paginatorInfo.currentPage+1;
                this.$apollo.queries.projects.fetchMore({
                    variables: {
                        page: this.currentPage,
                        first: this.pageSize,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        let data = {}
                        data.projects={
                            __typename: fetchMoreResult.projects.__typename,
                            // data: [...previousResult.projects.data, ...fetchMoreResult.projects.data],
                            data: uniqBy([...this.projects.data, ...fetchMoreResult.projects.data], 'id'),
                            paginatorInfo: fetchMoreResult.projects.paginatorInfo
                        }
                        return data
                    },
                })
            },
            refetchProjects(){
                if(this.$apollo.queries.projects) this.$apollo.queries.projects.refetch();
            },
            newProjectToProjectsList(project){
                if(project.id>0) this.projects.data.unshift(project);
                this.$emit('cancel', false);
            },
            scrollToProjectFunc(){
                setTimeout(function(){
                    if(!this.scrolled && this.scrollToProject && document.getElementById(this.scrollToProject)){
                        let offset=-100;
                        let moreFiltersEL=document.querySelector(".js-more-filters-nav");
                        if(moreFiltersEL) offset=offset-moreFiltersEL.offsetHeight;

                        this.$scrollTo('#'+this.scrollToProject, 200, {offset: offset})
                        this.scrolled=true;
                    }
                }.bind(this), 200);
            }
        },
        computed: {
            queryFilters(){
                if(!this.projectsFilter) return null;
                
                if(this.projectsFilter=='Archived') return {
                    allProjects: false,
                    archivedProjects: true,
                }
                if(this.projectsFilter=='Drafts') return {
                    draftProjects: true,
                }
                if(this.projectsFilter=='Confirmed') return {
                    confirmedProjects: true,
                }
                if(this.projectsFilter=='Actives') return {
                    activeProjects: true,
                }
                if(this.projectsFilter=='MyProjects' && this.myProfileID) return {
                    projectManager: this.myProfileID,
                    // activeProjects: true,
                }
                if(this.projectsFilter=='ToPlan') return {
                    status: "TOPLAN",
                    // activeProjects: true,
                }

                return null
            },
        },
        watch: {
            scrollToProject: function(){
            },
            loading: function(){
                if(this.loading) return
                this.$nextTick(function(){
                    this.onScroll()
                })
            },
            projectDateRange: function(){
                // this.projectList=null;
                this.notFetched=false;
                if(this.lastRange?.from!=this.projectDateRange.str.from) this.showProjects=false
                this.lastRange=JSON.parse(JSON.stringify(this.projectDateRange.str));

                this.scrolled=false;
                // this.$scrollTo(this.scrollToProject, 200, {offset:-60})
                setTimeout(function(){
                    if(!this.$apollo.queries.projects.loading) this.showProjects=true
                }.bind(this), 350)
            }
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-only',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data){
                    this.myProfileID=data.myProfile.id
                    return data
                }
            },
            projects: {
                query: PROJECTS,
                fetchPolicy: 'network-only',
                debounce: 500,
                watchLoading(isLoading){
                    this.loading=isLoading;
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables() {
                    let variables={};
                    if(this.projectDateRange) variables.dateRange=Object.assign(this.projectDateRange.str)
                    if(this.projectDateRange) variables.shiftsDateRange=Object.assign(this.projectDateRange.str)
                    if(this.projectIDs.length>0) variables.ids=this.projectIDs
                    if(this.moreFilters) variables.moreFilters=this.moreFilters
                    if (this.order.orderBy) {
                        variables.orderBy = this.order.orderBy
                    }
                    if (this.order.orderSort) {
                        variables.orderSort = this.order.orderSort
                    }


                    if(variables){
                        return {
                            ...this.queryFilters,
                            ...variables,
                            page: 1,
                            first: this.pageSize,
                        }
                    }
                },
                update(data) {
                    this.showProjects=true
                    this.projectList=data.projects;
                    this.$nextTick(function(){
                        if(this.scrollToProject){
                            this.scrollToFunc();
                        }
                    }.bind(this));
                    // this.scrollToProjectFunc();
                    return data.projects;
                },
            }
        },
    }
</script>

<style lang="scss" scoped>
    ul {
        margin: 0;
        list-style: none;
        padding: 0;
        display: inline-block;
        width: 100%;
        li {
            padding: 0;
            a, a:hover, a:active, a:visited {
                color: white;
            }
        }
        // width: auto;
        // margin-left: auto;
    }
</style>
